export const EMAIL_TITLES = {
  welcome: 'Welcome Letter',
  portalWelcome: 'Portal Welcome: Payment Due',
};
